import React from "react";
import classes from "./HelpAndFeedback.module.css";
import { withRouter } from "react-router-dom";
import Form from "./Form";
import { Row, Col, Card } from "react-bootstrap";
import MsgBox from "./MsgBox";
import { connect } from "react-redux";
import * as actions from "../../Action/Index";
import Loader from "react-loader-advanced";
import loading from "../../Assets/Images/loader-green.gif";
import Servererror from "../commonComponents/NetworkError/ServerError/Servererror";
import * as actionTypes from "../../Action/ActionTypes";

class HelpAndFeedback extends React.Component {
  state = {
    title: "",
    formData: "",
    error: "",
  };

  handleForm = (e) => {
    this.setState({
      formData: e.target.value.trim(),
      error: "",
    });
  };

  formSubmit = (e, title) => {
    e.preventDefault();
    if (this.validateFormField()) {
      this.props.onSubmitForm({
        message: this.state.formData,
        // type: title.toLowerCase(),
        userType: "CN",
      });
    }
  };

  confirm = (title) => {
    if (title === "Feedback") {
      this.props.history.push("/feedback");
    } else {
      this.props.history.push("/help");
    }
    this.setState({
      formData: "",
    });
    this.props.clear();
  };

  validateFormField = () => {
    let error = "";
    let status = true;

    if (this.state.formData === "") {
      status = false;
      error = "Field can not be empty.";
    } else if (this.state.formData.length < 50) {
      status = false;
      error = "Minimum 50 characters required.";
    }

    this.setState({
      error: error,
    });

    return status;
  };

  render() {
    let title = "";
    if (this.props.history) {
      title = this.props.history.location.pathname.split("/");
      title = title[1];
      if (title === "feedback") {
        title = "Feedback";
      } else if (title === "help") {
        title = "Help";
      }
    }

    return (
      <React.Fragment>
        <Row>
          <Col md={10}>
            <div className={classes.title}>
              <h3>Help/Feedback</h3>
            </div>
          </Col>
        </Row>
        <br />
        <br />
        <Loader
          show={this.props.feedbackLoader}
          message={<img src={loading} />}
          style={{ height: "450px" }}
          foregroundStyle={{ color: "#00a99d" }}
          backgroundStyle={{ backgroundColor: "#F3EFEF" }}
        >
          {!this.props.formSubmitted && !this.props.error && (
            <Row>
              <Col md={10}>
                <Form
                  handleForm={this.handleForm}
                  formSubmit={this.formSubmit}
                  title={title}
                  error={this.state.error}
                />
              </Col>
            </Row>
          )}
          {this.props.formSubmitted && (
            <MsgBox title={title} confirm={this.confirm} />
          )}
          {this.props.error && (
            <Servererror msg={this.props.errMsg} width="20%" />
          )}
        </Loader>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    feedbackLoader: state.employeeReducer.feedbackLoader,
    formSubmitted: state.employeeReducer.formSubmitted,
    error: state.employeeReducer.error,
    errMsg: state.employeeReducer.errMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmitForm: (data) => dispatch(actions.postHelpFeedback(data)),
    clear: () => dispatch({ type: actionTypes.HELP_AND_FEEDBACK_CLEAR }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HelpAndFeedback));
